export default "__VITE_ASSET__sKMLXnGy__"